import { useState, useEffect, useMemo,useRef } from 'react';

import api from '../../apis';
import moment from 'moment';
import ReactTable from '../general/form-control/react-table';

import { useFilter } from '../../context/FilterContext';
import { usePagination } from './helper';
import { numberWithCommas } from '../general/convertor';

import PortfolioRealizedHistoryModal from '../modals/PortfolioRealizedHistoryModal';
import PortfolioUnrealizedHistoryModal from '../modals/PortfolioUnrealizedHistoryModal';

const PortfolioRealizedTbl = ({
    orderNo
}:any) => {
    const { filterParams } = useFilter();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [_inputs, _setInputs] = useState({});
    const [accounts, setAccounts] = useState([]);
    const { tablePagination, setTablePagination } = usePagination();


    const [currencyGroupData,setCurrencyGroupData] = useState({});

    const currentPageSizeRef = useRef(10);

  
    useEffect(() => {
        handleFilter(filterParams)

    }, [filterParams]);


    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];
        requestTableData(accounts,1,filterParams);
        _setInputs(filterParams);
        setAccounts(accounts);
    }

    const requestTableData = async (accounts:string[],cPage=1,inputs:any={},cPageSize = null) =>{
        // if(accounts.length <1) {
        //     setTableData([])
        //     return 
        // }

        setTableData([])
       // if(!orderNo)return;
       //console.log("inputs",inputs)
       inputs.size = currentPageSizeRef.current;
        setLoading(true)
        let result = await api.getPortfolioRealized(accounts[0], inputs,cPage);
        //console.log("getPortfolioRealized result ",result)
        if(result.portfolio){
            let data = result.portfolio;
            let tableData = getFullTableData(data);
          //  console.log("_tableData",tableData)

            setTableData(tableData)

            let currencyGroupData = groupedByCurrency(tableData);
            //console.log("currencyGroupData",currencyGroupData)

            setCurrencyGroupData(currencyGroupData)


           // updateFooterRecord(tableData)
        }

        
        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

       setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }

    const getFullTableData = (tableData:any) =>{
       // console.log("tableData",tableData)
        let _tableData = JSON.parse(JSON.stringify(tableData));
        let cloneData = [..._tableData];
        for (let i = 0; i < cloneData.length; i++) {
            let ccy_rate = cloneData[i].ccy_rate;
           
            cloneData[i].cost = Number(cloneData[i].qty) * Number(cloneData[i].avg_bug_price);
            cloneData[i].cost_myr = Number(cloneData[i].cost) * Number(cloneData[i].ccy_rate);
            cloneData[i].sell_amount_myr = Number(cloneData[i].sell_amount) * Number(cloneData[i].ccy_rate);
            let changed = cloneData[i].avg_sell_price - Number(cloneData[i].avg_bug_price);
            const numChanged = Number.isNaN(changed) ? null : changed;
            cloneData[i].changed = numChanged;

        }

        
        return cloneData;
    }

    const calculateFooterCurrencyData = (data:any) => {
        let totalQuantity = 0;
        let totalCost = 0;
        let totalCostMyr = 0;
        let totalMarketValue = 0;
        let totalPnl = 0;
        let totalPnlPerc = 0;
        let totalSellAmount = 0;
        let totalSellAmountMyr = 0;



        data.forEach((row:any) => {
            let cost = Number(row.qty) * Number(row.avg_bug_price);
            totalQuantity += Number(row.qty);
            totalCost += Number(cost);
            totalCostMyr += Number(row.cost_myr);

            // totalMarketValue += Number(row. );
            totalPnl += Number(row.pnl);
            totalPnlPerc += Number(row.pnl_perc);
            totalSellAmount += Number(row.sell_amount);
            totalSellAmountMyr += Number(row.sell_amount_myr);
        });
        // setTotalQuantity(totalQuantity);
        // setTotalCost(totalCost);
        // setTotalCostMYR(totalCostMyr);
        // // setTotalMarketValue(totalMarketValue);
        // setTotalPnl(totalPnl);
        // setTotalPnlPerc(totalPnlPerc);
        // setTotalSellAmount(totalSellAmount);
        // setTotalSellAmountMYR(totalSellAmountMyr);

        return {
            totalQuantity,
            totalCost,
            totalCostMyr,
            totalMarketValue,
            totalPnl,
            totalPnlPerc,
            totalSellAmount,
            totalSellAmountMyr
        }
    }

    const tblColumns = useMemo(
        () => [
            {
                Header:'Name',
                accessor: 't_name',
                Cell: (data: any) => {
                    if(!data.value) return;
                    let row = data.row.original;
                    return <>
                        <div className="text-left">
                            {/* <PortfolioRealizedHistoryModal data={row} >
                                {data.value}
                            </PortfolioRealizedHistoryModal> */}

                            <PortfolioUnrealizedHistoryModal data={row} canEditPrice={false }>
                                {data.value}
                            </PortfolioUnrealizedHistoryModal>
                        </div>
                    </>;
                },
            },
            {
                Header:'Code',
                accessor: 't_code',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-left">
                                {v.value}
                            </div>
                        );
                }
            },
            {
                Header:'Exchange',
                accessor: 'e_name',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-left">
                                {v.value}
                            </div>
                        );
                }
            },
            {
                Header:'Quantity',
                accessor: 'qty',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value)}
                            </div>
                        );
                }
            },
            {
                Header:'Currency',
                accessor: 'c_code'
            },
            {
                Header:'Cost',
                accessor: 'cost',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'Cost (MYR)',
                accessor: 'cost_myr',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'Avg. Price',
                accessor: 'avg_bug_price',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'Changed',
                accessor: 'changed',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'Avg. Sell Price',
                accessor: 'avg_sell_price',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'Sell Value',
                accessor: 'sell_amount',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'Sell Value (MYR)',
                accessor: 'sell_amount_myr',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'PnL',
                accessor: 'pnl',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,3)}
                            </div>
                        );
                }
            },
            {
                Header:'PnL%',
                accessor: 'pnl_perc',
                Cell: (v: any) => {
                    if (v.value)
                        return (
                            <div className="text-right">
                                {numberWithCommas(v.value,2)}
                            </div>
                        );
                }
            }
        
        ],
        []
    );

    const groupedByCurrency  = (tableData:any) =>{
        return tableData.reduce((acc, item) => {
            if (!acc[item.c_code]) {
                acc[item.c_code] = [];
            }
            acc[item.c_code].push(item);
            return acc;
        }, {});
    }



    return (
        <>
            <ReactTable
                headerStyle={{
                    background: 'rgba(210, 209, 209, 1)',
                    color:"black"
                }}
                columns={tblColumns}
                data={tableData}
                pageSize={currentPageSizeRef.current}
                loading={loading}
                size='small'
                template="portfolio"
                CustomFooter={          
                    <>
                        {
                            Object.keys(currencyGroupData).map(currency => {
                                let row = currencyGroupData[currency];
                                let data = calculateFooterCurrencyData(row)

                                return (<>
                                         <tr>
                                            <td colSpan={2} className='p-2'>Total Value({currency})</td> 
                                            <td></td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalQuantity)}
                                                </div>
                                            </td> 
                                            <td></td>
                                       
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalCost,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalCostMyr,3)}
                                                </div>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalSellAmount,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalSellAmountMyr,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalPnl)}
                                                </div>
                                            </td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalPnlPerc,3)}
                                                </div>
                                            </td>
                                        </tr>
                                </>)
                            }) 
                        }
                    
                   </>
               
                    
                }
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                hasPagination

                ableChangePageSize={true}
                onPageSizeChanged={(cPageSize: number) => {
                   // alert(cPageSize)
                   currentPageSizeRef.current = cPageSize
                    requestTableData(accounts, 1 ,_inputs);
             
                }}
             
            />
        </>
    );
};

export default PortfolioRealizedTbl;
